<div class="wrapping-border">
    <div class="headerDiv">הגדר שעות איסוף/פיזור בתאריכים</div>
    <div class="container" [formGroup]="form">
        <div class="row">
            <div class="col-lg-5 txt col-set">
                <ng-container> החל מתאריך</ng-container>
                <div class="required">*</div>
            </div>
            <div class="col-lg-7 col-set">
                <mat-form-field [ngClass]="{required: isSubmited && form.controls.FromDate.errors}"
                    [class]="'DatePickerDiv inputText mat-form-field'" appearance="fill">
                    <input matInput [matDatepicker]="picker" (dateChange)="changefromDate($event)"
                        formControlName="FromDate">
                    <mat-datepicker-toggle matSuffix [for]="picker">
                        <i matDatepickerToggleIcon class="datepicker-icon"></i>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-5 txt col-set">עד תאריך
                <div class="required">*</div>
            </div>
            <div class="col-lg-7 col-set">
                <mat-form-field [ngClass]="{required: isSubmited && form.controls.ToDate.errors}"
                    [class]="' DatePickerDiv inputText mat-form-field'" appearance="fill">
                    <input matInput [min]="minDate" [matDatepicker]="picker2" formControlName="ToDate">
                    <mat-datepicker-toggle matSuffix [for]="picker2">
                        <i matDatepickerToggleIcon class="datepicker-icon"></i>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="txt col-lg-5 col-set">תיאור התקופה
                <div class="required">*</div>
            </div>
            <div class="col-lg-7 col-set">
                <select formControlName="vacationType"
                    [ngClass]="{required: isSubmited && form.controls.vacationType.errors}"
                    (change)="checkChosen($event)" class="select form-control">
                    <option value=""></option>
                    <option *ngFor="let d of calendarSvc.PeriodDescriptionList" [ngValue]="d">
                        {{ d.viewValue }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row" *ngIf="elseChosen">
            <div class="txt col-lg-5 col-set">פירוט
                <div class="required">*</div>
            </div>
            <div class="col-lg-7 col-set">
                <input formControlName="description" class="inputText form-control" type="text"
                    [ngClass]="{required: isSubmited && form.controls.description.errors}">
            </div>
        </div>
        <div class="row">
            <div class="txt col-lg-5">יום קצר
            </div>
            <div class="col-lg-7 ">
                <div class="custom-control custom-switch custom-switch-xl">
                    <input type="checkbox" (change)="OnSwitch($event.target.checked)" class="custom-control-input"
                        id="customSwitch2" formControlName="IsShortDay">
                    <label class="custom-control-label" for="customSwitch2"></label>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="form.controls['IsShortDay'].value==true">
            <div class="txt col-lg-5 col-set">שעת פיזור
                <div class="required">*</div>
            </div>
            <div class="selectDiv col-lg-7 col-set">
                <select formControlName="EndTime" [attr.disabled]="form.controls['IsShortDay'].value==true?null:'' "
                    [ngClass]="{required: isSubmited && form.controls.EndTime.errors}"
                    class="select form-control ng-pristine ng-valid ng-touched">
                    <option selected></option>
                    <option [ngValue]="hour" *ngFor="let hour of calendarSvc.ScheduleHoursList">{{hour.viewValue}}
                    </option>
                </select>
            </div>
        </div>
        <div class="a contant-inputs upload-file">
            <div class="b input-worp first-worp vertical-buttons">
                <label for="fileUpload" class="upload-button-style">
                    <span>העלה קובץ</span>
                    <input id="fileUpload" type="file" multiple (change)="onFilesSelected($event)"
                        accept=".pdf,.doc,.docx,.txt,.xlsx,.xls,.csv,.png,.jpg,.jpeg,.eml,.msg,.zip,.rar,.ppt,.pptx" />
                </label>

                <button type="button" class="upload-button-style" (click)="addStandaloneNote()"
                    style="margin-right: 10px;" [disabled]="standaloneNotes.length >= 1"
                    [ngClass]="{'disabledButton': standaloneNotes.length >= 1}">
                    <span>הוסף הערה</span>
                </button>

            </div>

            <div class="uploaded-files-list">
                <div *ngFor="let f of existingFiles; let i = index" class="file-item">
                    <a (click)="downloadFile(f.FileId, f.FileName)" class="download-link">{{ f.FileName }}</a>
                    <textarea [value]="f.Note" (input)="existingFiles[i].Note = $event.target.value"
                        placeholder="הערה לקובץ" rows="2" class="comment-box"></textarea>
                </div>

                <div *ngFor="let f of newFiles; let i = index" class="file-item">
                    <span>{{ f.FileName }}</span>
                    <textarea [value]="f.Note" (input)="newFiles[i].Note = $event.target.value" placeholder="הערה לקובץ"
                        rows="2" class="comment-box"></textarea>
                </div>
                <div *ngFor="let note of standaloneNotes; let i = index" class="file-item standalone-note">
                    <div class="standalone-note-header">
                        <span class="standalone-note-title">הערה</span>
                    </div>
                    <textarea [value]="note.Note" (input)="standaloneNotes[i].Note = $event.target.value"
                        placeholder="הזן הערה" rows="3" class="comment-box"></textarea>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="d-flex justify-content-center margin-top-10">
    <button type="submit"
        [disabled]="!enableUpdateAll && ((!selectedVacations|| selectedVacations.length==0) ||(selectedVacations.length>0 && selectedStudents.length>0))"
        [ngClass]="{disabledButton: !enableUpdateAll && ((!selectedVacations|| selectedVacations.length==0) ||(selectedVacations.length>0 && selectedStudents.length>0))}"
        class="button save-button" (click)="updateAll()">עדכן חופשה
        כיתתית</button>
    <button type="submit" [disabled]="enableUpdateAll || (selectedStudents && selectedStudents.length==0)"
        [ngClass]="{disabledButton:enableUpdateAll || (selectedStudents && selectedStudents.length==0)}"
        class="button save-button blue" (click)="updateSelectedStudents()">עדכן חופשה לתלמידים שנבחרו</button>
</div>